import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { Circle } from 'lucide-react';
import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

const radioGroupItemVariants = cva(
    'rocco-radio-group-item flex aspect-square h-2.5 w-2.5 cursor-pointer items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
    {
        variants: {
            variant: {
                default:
                    'rounded-full border border-primary-foreground text-primary-foreground ring-offset-background',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    OmitStylesComponentProps<typeof RadioGroupPrimitive.Item> &
        VariantProps<typeof radioGroupItemVariants>
>(({ variant, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={radioGroupItemVariants({ variant })}
            {...props}
        >
            <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                <Circle className="h-2.5 w-2.5 fill-current text-current" />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
